export default {
  save: 'Enregister',
  cancel: 'Annuler',
  no_results: 'Aucun resultat pour cette recherche',
}